export const HEADERS_OTHER: HeadersInit = {
  "Content-Type": "application/json",
};
